<template>
	<div class="home">
		<Map @hideEvents="hideTodaysEvents" ref="map"/>
		<MapControls />
		<MapNav />
		<Directory @showEvents="showTodaysEvents" />
		<MapContentOverlay ref="mapOverlay"/>
		<PrimaryNav ref="primaryNav" @selectEvent="selectEvent" @closeEventCard="closeEventCard"/>
		<LanguageSelect />
	</div>
</template>

<script>
	// @ is an alias to /src
	import Directory from "@/components/Directory.vue";
	import Map from "@/components/Map.vue";
	import MapNav from "@/components/MapNav.vue";
	import MapControls from "@/components/MapControls.vue";
	import MapContentOverlay from '@/components/MapContentOverlay.vue';
	import PrimaryNav from '@/components/PrimaryNav.vue';
	import LanguageSelect from '@/components/LanguageSelect.vue';

	export default {
		name: "Home",
		components: {
			Directory,
			Map,
			MapNav,
			MapControls,
			MapContentOverlay,
			PrimaryNav,
			LanguageSelect
		},
		methods: {
			showTodaysEvents: function() {
				this.$refs.primaryNav.showTodaysEvents();
			},
			hideTodaysEvents: function() {
				this.$refs.primaryNav.hideTodaysEvents();
			},
			selectEvent: function(prefix) {
				this.$refs.primaryNav.hideTodaysEvents();
				this.$refs.map.selectRoom(null, prefix);
			},
			closeEventCard: function() {
				this.$refs.mapOverlay.triggerHide();
			}
		}
	};
</script>

<style scoped lang="scss">
	.home {
		position: relative;
		height: calc(100% - 70px);
		margin-top: 70px;
		overflow: hidden;
	}
</style>
